exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2KpZMYSiDizjEs{height:20px;border-radius:3px;display:flex;align-items:center;justify-content:center;flex-direction:column;overflow:hidden;width:70%;margin:0 auto}._2KpZMYSiDizjEs:before{content:\"\";display:block;width:100%}._3Zo5oGEJ9Enqr7:before{border-top:2px solid #c1c7d0}", ""]);

// exports
exports.locals = {
	"separatorCard": "_2KpZMYSiDizjEs",
	"singleHorizontalLine": "_3Zo5oGEJ9Enqr7"
};